import React, { useRef } from "react";
import Page from "../../page-layout";
import { BackButton } from "@core/components";
import MaxWidthContainer from "../../../components/UI/MaxWidthContainer/MaxWidthContainer";
import { useAuth } from "../../../contexts/auth-context";
import { useInfiniteGetOrdersHistoryQuery } from "../../../providers/Orders";
import { IonInfiniteScroll, IonInfiniteScrollContent, IonSkeletonText, useIonViewWillEnter } from "@ionic/react";
import { useHistory } from "react-router-dom";
import { useConfig } from "../../../providers/config";
import OrderCard from "./order-card";
import PullToRefresh from "../../../parhato2/src/entities/pullToRefresh";
import { useTranslation } from "react-i18next";

const MyOrders = () => {
  const { t } = useTranslation();
  const config = useConfig();
  const { user } = useAuth();
  const history = useHistory();

  const page = useRef<number>(1);
  const infinite = useRef(null as any);
  const ionContentRef = useRef<HTMLIonContentElement>(null);

  const infiniteGetOrdersHistoryQueryEnabled = !!user?.id;

  const {
    data: ordersHistory,
    fetchNextPage,
    hasNextPage,
    isLoading: isLoadingOrdersHistory,
  } = useInfiniteGetOrdersHistoryQuery({
    params: { page: page.current, per_page: 10 },
    options: {
      enabled: infiniteGetOrdersHistoryQueryEnabled,
    },
  });

  const ordersMap = ordersHistory?.pages.flat();

  useIonViewWillEnter(() => {
    if (history.action === "PUSH") {
      ionContentRef.current?.scrollToTop();
      page.current = 1;
    }
  }, []);

  const isLoading = infiniteGetOrdersHistoryQueryEnabled && isLoadingOrdersHistory;

  const handleGoHome = () => {
    history.replace("/home3");
  };

  return (
    <Page>
      <Page.Header className="pt-[env(safe-area-inset-top)]">
        <MaxWidthContainer classList="w-full px-2.5 bg-white h-16 bg-white grid grid-cols-3 items-center">
          <BackButton buttonStyles="justify-self-start ml-0" onClickButton={handleGoHome} />
          <h1 className="absolute left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2 text-[1.125rem] font-bold">
            {t("Order history")}
          </h1>
        </MaxWidthContainer>
      </Page.Header>
      <Page.Content>
        <PullToRefresh />
        <MaxWidthContainer classList={"flex flex-col gap-2.5 px-2.5 "}>
          {isLoading ? (
            <div className="flex flex-col gap-2.5 w-full px-2.5">
              <IonSkeletonText animated className="h-[7.25rem] rounded-xl" />
              <IonSkeletonText animated className="h-[7.25rem] rounded-xl" />
              <IonSkeletonText animated className="h-[7.25rem] rounded-xl" />
              <IonSkeletonText animated className="h-[7.25rem] rounded-xl" />
            </div>
          ) : (
            <>
              <div className="flex flex-col gap-2.5">
                {ordersMap?.map((order) => {
                  return <OrderCard key={order.id} order={order} />;
                })}
              </div>
              {config?.orderHistoryPagination && (
                <IonInfiniteScroll
                  ref={infinite}
                  threshold="100px"
                  onIonInfinite={async () => {
                    if (hasNextPage) {
                      await fetchNextPage();
                    }
                    requestAnimationFrame(() => {
                      infinite.current?.complete();
                    });
                  }}
                >
                  <IonInfiniteScrollContent loadingText={t("Please Wait")} loadingSpinner="bubbles" />
                </IonInfiniteScroll>
              )}
            </>
          )}
        </MaxWidthContainer>
      </Page.Content>
    </Page>
  );
};

export default MyOrders;
